import _ from 'underscore';
import Cache from 'root/cache';
import Modals from 'root/modals';
import View from 'view/base';
import View_Integrations from 'view/feedback_integrations';
import View_Feedback_Sidebar from 'view/feedback_sidebar/index';
import View_Feedback_Comments from 'view/feedback_sidebar/comments';
import { toggleWatch } from 'service/feedback';
import Template_Action_Dropdown from 'template/feedback/action_dropdown';

export default View.extend({
    className: 'feedback-inbox',

    dispatcher: _.extend({}, Backbone.Events),

    views: {
        integrations: {},
        sidebar: {},
        comments: {},
    },

    events: {
        'click .collapse-toggle'   : 'onToggleSessionDetails',
        'click .feedback-share'    : 'onShare',
        'click .feedback-rename'   : 'onRename',
        'click .feedback-merge'    : 'onMergeFeedback',
        'click .feedback-unmerge'  : 'onUnmerge',
        'click .feedback-publish'  : 'onPublish',
        'click .feedback-move'     : 'onMove',
        'click .feedback-delete'   : 'onDelete',
        'click .feedback-watch'    : 'onWatch',
        'dblclick .feedback-title' : 'onRename',
    },

    dom_handlers: {
        onToggleSessionDetails: function(e) {
            Cache.app.dispatcher.trigger('Feedback:Open', this.model.id);
        },

        onRename: function(e) {
            if (Cache.app.isClient()) {
                return;
            }

            if (this.model.isDesign() || this.model.isPdf() || this.model.isVideoUpload()) {
                Modals.renameDesign(this.model.id);
            } else {
                Modals.renameFeedback(this.model.id);
            }
        },

        onShare: function(e) {
            Modals.shareFeedback(this.model);
        },

        onWatch: function(e) {
            toggleWatch(this.model.id);
        },

        onPublish: function(e) {
            if (this.model.isMergedFeedback()) {
                return;
            }

            if (this.model.get('is_portal_approved')) {
                Modals.unapproveFeatureRequest(this.model);
            } else {
                Modals.approveFeatureRequest(this.model);
            }
        },

        onMove: function(e) {
            Modals.moveFeedback([this.model.id]);
        },

        onMergeFeedback: function(e) {
            Modals.mergeFeedback(this.model.id, [], {
                initial_search_feedbacks: this.initial_search_feedbacks,
            });
        },

        onUnmerge: function(e) {
            Modals.unmergeFeedback(this.model.id);
        },

        onDelete: function(e) {
            Modals.deleteFeedback([this.model.id]);
        },

    },

    initialize: function(options) {
        this.initial_search_feedbacks = options.initial_search_feedbacks;
        this.dispatcher =  _.extend({}, Backbone.Events);

        // integrations
        this.views.integrations = new View_Integrations({
            model: this.model
        });

        // sidebar
        this.views.sidebar = new View_Feedback_Sidebar({
            feedback_id: this.model.id,
            inbox_mode: true,
            dispatcher: this.dispatcher
        });

        // comment view
        this.views.comments = new View_Feedback_Comments({
            model: this.model,
            dispatcher: this.dispatcher,
            inbox_mode: true
        });

        this.listenTo(this.model, 'change:title', this.renderTitle);
        this.listenTo(Cache.feedback_watch_list, 'add', this.renderWatchButton);
        this.listenTo(Cache.feedback_watch_list, 'remove', this.renderWatchButton);
    },

    renderTitle: function() {
        this.$el.find('.feedback-title').text(this.model.get('title') || 'Untitled');
    },
    renderWatchButton: function() {
        var is_feedback_watched = Cache.feedback_watch_list.findWhere({feedback_id: this.model.id, user_id: Cache.real_user_id});
        this.$el.find('.feedback-watch').text(is_feedback_watched ? 'Unfollow' : 'Follow');
    },

    render: function() {
        var content =
        '<div class="region-main">' +
            '<div class="region-actions">' +
                '<div>' +
                    '<div class="flex-start">' +
                        '<div class="feedback-id badge-id">' + this.model.id + '</div>' +
                        (this.model.get('sentiment') ?
                        '<div class="feedback-sentiment tooltip" data-title="User sentiment: ' + this.model.getSentimentText() + '">' + this.model.getSentimentIcon() + '</div>' : '') +
                    '</div>' +
                    (Cache.app.isClient() ? '' :
                    '<div class="flex-c region-integrations">' +
                        '<div class="button-dropdown">' +
                            '<button type="button" class="ellipsis"><i class="far fa-ellipsis-h"></i></button>' +
                            '<div>' +
                                Template_Action_Dropdown(this.model) +
                            '</div>' +
                        '</div>' +
                    '</div>') +
                '</div>' +
            '</div>' +
            '<div class="region-comments">' +
                '<div>' +
                    '<div class="feedback-title"></div>' +
                '</div>' +
            '</div>' +
        '</div>' +
        '<div class="region-side"></div>';

        this.$el.html(content);

        this.renderTitle();

        // integrations
        this.views.integrations.render().$el.prependTo(this.$el.find('.region-integrations'));

        // sidebar
        this.views.sidebar.render().$el.appendTo(this.$el.find('.region-side'));

        // comments
        this.views.comments.render().$el.appendTo(this.$el.find('.region-main .region-comments > div'));

        return this;
    }
});